<template>
  <label class="icon-box hidden-box" @click="showEditor">
    <auth-img class="icon-img" src="@/assets/img/chat/add-summary.png" alt="" />
    <div class="icon-label">添加小结</div>
    <EditSummary ref="editSummaryRef" @changeTab="() => emit('changeTab', 1)" />
  </label>
</template>
<script setup>
import EditSummary from '@/views/WorkPlace/Container/Summary/editSummary.vue'
import { ref, defineProps, defineEmits } from 'vue'
const props = defineProps({
  privateId: {
    type: String,
    required: true
  },
  workOrderGroupInfo: {
    type: Object,
    default: () => {}
  }
})
const emit = defineEmits(['changeTab'])
const editSummaryRef = ref(null)
const showEditor = () => {
  const { patientInfo = {}, doctorInfo = {}, targetWorkOrder = {} } = props.workOrderGroupInfo
  const params = {
    privateId: props.privateId,
    type: 0,
    groupInfo: {
      ...patientInfo,
      patientProfileCommonVO: {
        patientProfileName: patientInfo?.username,
        gender: patientInfo?.gender,
        age: patientInfo?.age
      },
      patientName: patientInfo?.username,
      doctorName: doctorInfo?.username,
      ucDoctorId: doctorInfo?.ucUserId
    },
    workOrderId: targetWorkOrder.workOrderId
  }
  editSummaryRef.value?.initModal(params)
}
</script>
<style lang="scss" scoped>
@import '../../index.scss';
</style>
